import React from 'react';

const About = () => {
    return (
        <div>
            <h3>Purpose</h3>
            <p>
                The objective of this project is to develop a system that utilizes multimodal techniques to detect deceptive design elements in applications. By combining visual and textual cues, the system will identify potentially misleading or deceptive designs, aiding in improving user trust and experience.
            </p>
            <p>
                <strong>Main Focus:</strong> Automated user journey path, image extraction, multimodal LLM analysis, human review, and standardized reporting.
            </p>
            <p>
                <strong>Context:</strong> Detecting deceptive designs is complex and may require expert time. It may also be constrained by time and scale when it comes to examining multiple web pages or applications.
            </p>

            <h3>High-Level Process View</h3>
            <p>Overall process visualized in the Miro board:</p>

            {/* Embedding Miro images using iframe */}
            <iframe
                src="https://miro.com/app/board/uXjVKt0Metw=/?moveToWidget=3458764596068411446&cot=14"
                width="100%"
                height="600px"
                frameBorder="0"
                allowFullScreen
                title="High-Level Process View"
            ></iframe>

            <h3>Backend FLow diagram</h3>
            <iframe
                src="https://miro.com/app/board/uXjVKt0Metw=/?moveToWidget=3458764596073267182&cot=14"
                width="100%"
                height="600px"
                frameBorder="0"
                allowFullScreen
                title="Second Image"
            ></iframe>

            <h3>Chrome Extension flow Diagram</h3>
            <iframe
                src="https://miro.com/app/board/uXjVKt0Metw=/?moveToWidget=3458764596068411534&cot=14"
                width="100%"
                height="600px"
                frameBorder="0"
                allowFullScreen
                title="Third Image"
            ></iframe>

            <h3>Agents Flow diagram</h3>
            <iframe
                src="https://miro.com/app/board/uXjVKt0Metw=/?moveToWidget=3458764596070691463&cot=14"
                width="100%"
                height="600px"
                frameBorder="0"
                allowFullScreen
                title="Fourth Image"
            ></iframe>

            {/* Embedding Google Drive Video for Application Flow */}
            <h3>Video: How to Run the Application</h3>
            <iframe 
                src="https://drive.google.com/file/d/12BBHoJh08j8d6VAViJmXVzE_ofGsIhOq/preview" 
                width="100%" 
                height="480" 
                allow="autoplay" 
                title="Application Flow Video">
            </iframe>
            {/* Embedding Google Drive Video for Chrome Extension Flow */}
            <h3>Video: How to Use the Chrome Extension</h3>
            <iframe 
                src="https://drive.google.com/file/d/1eYsjl4DAb8mAAJx_6Ji0kPLIQzAy4woz/preview" 
                width="100%" 
                height="480" 
                allow="autoplay" 
                title="Chrome Extension Flow Video">
            </iframe>
        </div>
    );
};

export default About;
